import React from 'react';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

import BouncingPreloader from '../common/bouncyLoader';

import PMGantt from './pm_gantt/pm_gantt';
import { red } from '@mui/material/colors';

const PREFIX = 'PMs';

const classes = {
  paper: `${PREFIX}-paper`,
  pm_gantt: `${PREFIX}-pm_gantt`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.paper}`]: {
      maxWidth: '95vw',
      minHeight: '85vh',
  },

  [`& .${classes.pm_gantt}`]: {
    backgroundColor: red,
  }
}));

//Function that pulls the data and sends it to the Table Renderer
const PMs = props => {
    let {pm_view_data, loading, showDetailedView, toggleDetailView, updateDetailView, filters, sort_by, handleSortByChange} = props;


    return (
      <Root>
        {loading ? (
          <>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <BouncingPreloader />
            </div>
          </>
        ) : (
          <Paper elevation={7} className={classes.paper} key={pm_view_data}>
              <PMGantt 
                data={pm_view_data} 
                sort_by={sort_by}
                handleSortByChange={handleSortByChange}
                className={classes.pm_gantt}
                showDetailedView={showDetailedView}
                toggleDetailView={toggleDetailView}
                updateDetailView={updateDetailView}
                filters={filters}
              />
          </Paper>
        )}
      </Root>
    );
};


export default PMs;